import React, { useEffect } from "react";
import { useContext } from "react";
import { renderedContext } from "../context/context";
import { isMobileDevice, isTV } from "./Render";
export const Input = ({className, size, type, id, children, style, onChange, onKeyDown,extraProps})=>
{
    let textInput = null; 

    // Shown, not played (the quiz builder's cards and its preview). This effect has no dependency
    // array, so it runs after EVERY render: on a page of questions each pass pulled focus into one
    // of the inputs and the browser scrolled the list to it. A child plays one question at a time
    // and still gets the focus.
    const state = useContext(renderedContext);
    const isReadOnly = state?.readOnly === true;

    /**
   * ONCE, when the question arrives - not after every render.
   *
   * The engine moves the focus itself as the student fills the boxes (its shiftFocus marks the next
   * box with the focus class and calls focus() on it), so there is nothing for this to do afterwards.
   * Running on every render, it dragged the focus back to whichever box the question's CONFIG says is
   * first - which is where it went every time anything set state, including saving an answer.
   */
    useEffect(()=>{
    if(!isReadOnly && className.includes('focusTextBox'))
     textInput.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /**
   * NO `value`: what is in the box belongs to the DOM, which is where it is written.
   *
   * The ENGINE writes this box - its on-screen keypad and a real keyboard both go straight to
   * `.value` - so React never knows what is in it. Holding a `value` of its own meant the two
   * disagreed, and every re-render put React's empty string back over the student's answer: typing
   * while a sound played lost it, saving an answer lost it, and so would anything else that set
   * state while the question was up. Each of those was patched where it happened. Without a `value`
   * there is nothing to put back and nothing to patch.
   *
   * A question is drawn into an emptied tree - every screen sets `response: { component: [] }` first
   * - so each question gets its own box, and nothing carries over from the last one. Where an answer
   * SHOULD be wiped mid-question, it is wiped on purpose: see clearInputBoxes in
   * CheckAnswerAdaptivePractice, which is what empties the box for a second attempt.
   */
  const handleNumChange = () => {
    // The student has typed something - see markTouched in PlayFrame. Only a key the browser handles
    // reaches here; the rest the engine takes, and the frame counts those as they arrive.
    state?.markTouched?.();
  };
    
    return (
        <input id={id} className={className} style={style} onChange={handleNumChange}
        placeholder={children} maxLength={size} size={size} type="text" 
        autoFocus={!isReadOnly} autoComplete="off" onKeyDown={onKeyDown} 
        direction={extraProps&&extraProps.direction?extraProps.direction:1}
        position={extraProps&&extraProps.position?extraProps.position:null}
        onWheel={(e) => e.target.blur()} readOnly={isReadOnly || isMobileDevice() || isTV()}
        ref={(input) => { textInput = input; }}/>
     );
}